import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";

const useEmbeds = () => {
  const pathname = usePathname() ?? "";
  const [isInsideIframe, setIsInsideIframe] = useState(false);
  const [isInsideIframeAndOnCurrentUrl, setIsInsideIframeAndOnCurrentUrl] =
    useState(false);

  useEffect(() => {
    if (window.self !== window.top) {
      setIsInsideIframe(true);

      if (
        document.referrer?.split("/")[2]?.replace(/\/$/, "") ===
        window.location.hostname?.replace(/\/$/, "")
      )
        setIsInsideIframeAndOnCurrentUrl(true);
    }
  }, []);

  return {
    isEmbed: pathname.includes("/embeds/"),
    isInsideIframeAndOnCurrentUrl,
    isInsideIframe
  };
};

export default useEmbeds;
